module.exports = __webpack_public_path__ + "4d96f954e4c3b2c577aa7fdf9aec2e9a.svg";